"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfCapabilityClient = void 0;
var ApplicationVersion;
(function (ApplicationVersion) {
    ApplicationVersion[ApplicationVersion["V1"] = 1] = "V1";
    ApplicationVersion[ApplicationVersion["V2"] = 2] = "V2";
    ApplicationVersion[ApplicationVersion["V3"] = 3] = "V3";
})(ApplicationVersion || (ApplicationVersion = {}));
// https://cardata.apps.emea.vwapps.io/documentation#tag/Capabilities
class VcfCapabilityClient {
    constructor(authServiceWeConnect, loggingFacade, stage) {
        this.authServiceWeConnect = authServiceWeConnect;
        this.loggingFacade = loggingFacade;
        this.stage = stage;
        this.headers = {
            'User-Id': '__userId__',
        };
        this.getGdcType = (isWcar) => (isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`);
        this.resourceHostId = `myvw-vcf-${stage}`;
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Capabilities/operation/getUserCapabilities
    async getUserVehicleCapabilities(vin, isWcar) {
        const headers = Object.assign(Object.assign({}, this.headers), { Accept: `application/json;version=${ApplicationVersion.V3}`, data: JSON.stringify({}), 'Content-Type': `application/json;version=${ApplicationVersion.V3}` });
        const url = `vehicles/${vin}/usercapabilities?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url, headers);
        if (response.status === 404) {
            return {};
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Capabilities/operation/postUserCapabilities
    async setUserVehicleCapabilityEnabled(vin, isWcar, capabilityId, enabled) {
        const headers = Object.assign(Object.assign({}, this.headers), { Accept: `application/json;version=${ApplicationVersion.V2}`, 'Content-Type': `application/json;version=${ApplicationVersion.V2}` });
        const url = `vehicles/${vin}/usercapabilities?gdc=${this.getGdcType(isWcar)}`;
        const data = {
            capabilities: [
                {
                    id: capabilityId,
                    enabled: enabled,
                },
            ],
        };
        const response = await this.authServiceWeConnect.post(this.resourceHostId, url, JSON.stringify(data), headers);
        if (!response.ok) {
            this.loggingFacade.error('Could not set user vehicle capability enabled', new Error(`Request failed with status code ${response.status}`));
            return undefined;
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Capabilities/operation/getSetUsercapabilitiesRequestStatus
    async getCapabilityUpdateStatus(vin, isWcar, requestId) {
        const url = `vehicles/${vin}/usercapabilities/requests/${requestId}?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url, this.headers);
        if (!response || !response.ok) {
            this.loggingFacade.error('Could not get capability update status', new Error());
            return undefined;
        }
        return await response.json();
    }
}
exports.VcfCapabilityClient = VcfCapabilityClient;
//# sourceMappingURL=VcfCapabilityClient.js.map